/* Smalley Coffee — Phase 1 storefront behaviors.
   Plain vanilla; no framework. Each behavior is self-contained and defensive
   so a failure in one never blocks the page. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Rotators — cross-fade a stack of layers on an interval. Used by the home
     hero and by the brew-guide photo on the product page.
     Pauses while the tab is hidden; honors prefers-reduced-motion (holds
     on the first image and never starts the timer).
     --------------------------------------------------------------------- */
  function initRotators(rootSelector, layerSelector, fallbackInterval) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll(rootSelector).forEach(function (root) {
      var layers = root.querySelectorAll(layerSelector);
      if (layers.length < 2 || reduce) return;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || fallbackInterval;
      var i = 0;
      var timer = null;
      function advance() {
        layers[i].classList.remove('is-active');
        i = (i + 1) % layers.length;
        layers[i].classList.add('is-active');
      }
      function start() { if (!timer) timer = setInterval(advance, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      start();
    });
  }
  function initHeroRotators() {
    initRotators('[data-hero-rotator]', '.sc-hero__layer', 6000);
    initRotators('[data-brew-rotator]', '.sc-brew__layer', 5000);
  }

  /* ---------------------------------------------------------------------
     Geolocation + weather for the masthead. Non-blocking, silent failure,
     falls back to Jasper, Indiana. Never throws.
     --------------------------------------------------------------------- */
  var WMO = {
    0: 'Clear', 1: 'Mostly clear', 2: 'Partly cloudy', 3: 'Overcast',
    45: 'Fog', 48: 'Fog', 51: 'Drizzle', 53: 'Drizzle', 55: 'Drizzle',
    61: 'Rain', 63: 'Rain', 65: 'Heavy rain', 71: 'Snow', 73: 'Snow',
    75: 'Heavy snow', 80: 'Showers', 81: 'Showers', 82: 'Showers',
    95: 'Thunderstorms', 96: 'Thunderstorms', 99: 'Thunderstorms'
  };
  function initGeo() {
    var coordsEl = document.querySelector('[data-geo-coords]');
    var weatherEl = document.querySelector('[data-geo-weather]');
    if (!coordsEl && !weatherEl) return;
    function fmt(v, pos, neg) { return Math.abs(v).toFixed(2) + '°' + (v >= 0 ? pos : neg); }
    function resolve(lat, lon) {
      if (coordsEl) coordsEl.textContent = fmt(lat, 'N', 'S') + ' ' + fmt(lon, 'E', 'W');
      if (!weatherEl) return;
      fetch('https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lon +
            '&current=temperature_2m,weather_code&temperature_unit=fahrenheit&timezone=auto')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var c = d && d.current;
          if (!c) return;
          weatherEl.textContent = (WMO[c.weather_code] || 'Clear') + ' · ' + Math.round(c.temperature_2m) + '°F';
        })
        .catch(function () {});
    }
    var fallback = function () { resolve(38.39, -86.93); };
    try {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (p) { resolve(+p.coords.latitude.toFixed(2), +p.coords.longitude.toFixed(2)); },
          fallback,
          { timeout: 6000, maximumAge: 600000 }
        );
      } else { fallback(); }
    } catch (e) { fallback(); }
  }

  /* ---------------------------------------------------------------------
     Add to bag — Cart AJAX API. Optimistic header count bump, then open the
     cart drawer (Dawn's) on success. Works from collection cards and any
     [data-sc-add] control carrying a data-variant-id.
     --------------------------------------------------------------------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }
  function refreshCartDrawer(sections) {
    // Ask Dawn's cart-drawer to re-render if present.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections && typeof drawer.renderContents === 'function') {
      // The drawer is server-rendered with `is-empty` when the cart was empty
      // on page load, and Dawn's CSS hides `.cart__contents` while that class
      // is set. renderContents() swaps the markup but leaves the class alone —
      // Dawn strips it in product-form.js, which this add-to-bag path bypasses.
      // Without this the first add of a session opens a blank drawer.
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      try { drawer.renderContents({ sections: sections, id: 'cart-drawer' }); return true; } catch (e) {}
    }
    return false;
  }
  function initAddToBag() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sc-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) { window.location.href = btn.getAttribute('data-url') || (window.routes ? window.routes.cart_url : '/cart'); return; }
      if (btn.disabled) return;
      var labelEl = btn.querySelector('[data-add-label]') || btn;
      var original = labelEl.textContent;
      btn.disabled = true;
      labelEl.textContent = 'Adding…';

      var drawer = document.querySelector('cart-drawer');
      var item = { id: Number(variantId), quantity: Number(btn.getAttribute('data-quantity')) || 1 };
      var sellingPlan = btn.getAttribute('data-selling-plan');
      if (sellingPlan) { item.selling_plan = Number(sellingPlan); }
      var body = { items: [item] };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) { throw new Error(res.description || 'Add failed'); }
          labelEl.textContent = 'Added ✓';
          // Pull the fresh count.
          return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              refreshCartDrawer(res.sections);
              if (drawer && typeof drawer.open === 'function') { drawer.open(btn); }
            });
        })
        .catch(function () {
          labelEl.textContent = 'Try again';
        })
        .finally(function () {
          setTimeout(function () { btn.disabled = false; labelEl.textContent = original; }, 1600);
        });
    });
  }

  /* ---------------------------------------------------------------------
     Bag link — open Dawn's cart drawer instead of navigating, when the
     store uses the drawer cart. Falls through to /cart otherwise.
     --------------------------------------------------------------------- */
  function initCartToggle() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-sc-cart-toggle]');
      if (!link) return;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && !drawer.classList.contains('is-empty') && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open(link);
      } else if (drawer && typeof drawer.open === 'function') {
        // Empty drawer still opens (shows the empty state).
        e.preventDefault();
        drawer.open(link);
      }
      // else: no drawer -> allow default navigation to /cart
    });
  }

  /* ---------------------------------------------------------------------
     Gallery — swap the main product image when a thumbnail is clicked.
     Instant, no transition.
     --------------------------------------------------------------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (!src) return;
          var prev = main.getAttribute('src');
          main.setAttribute('src', src);
          // Let the clicked thumbnail show the previously-main image (swap).
          var img = thumb.querySelector('img');
          if (img && prev) { img.setAttribute('src', prev); thumb.setAttribute('data-src', prev); }
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Product form — chip variant picker + quantity + subscribe. Updates the
     price, total, SKU, and the add button's variant id without a reload.
     --------------------------------------------------------------------- */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString());
  }
  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-product-variants]');
      var addBtn = form.querySelector('[data-sc-add]');
      if (!dataEl || !addBtn) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';
      var totalEl = form.querySelector('[data-total]');
      var labelEl = form.querySelector('[data-add-label]');
      var qtyValEl = form.querySelector('[data-qty-val]');
      var qty = 1;

      // Selected option values, seeded from the initial variant on the button.
      var initId = Number(addBtn.getAttribute('data-variant-id'));
      var initVariant = variants.filter(function (v) { return v.id === initId; })[0] || variants[0];
      var selected = initVariant ? initVariant.options.slice() : [];

      function matchVariant() {
        return variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        })[0];
      }
      // Purchase option — subscription is preselected in the markup, so the
      // selling plan has to be applied on load too. Reading .checked at init
      // rather than only on change is the whole point: without it the page
      // shows "Subscribe" while quietly adding a one-time bag to the cart.
      var planRadios = form.querySelectorAll('input[name="sc-purchase"]');
      var subPriceEl = form.querySelector('[data-plan-price-sub]');
      var oncePriceEl = form.querySelector('[data-plan-price-once]');

      function activePlanId() {
        for (var i = 0; i < planRadios.length; i++) {
          if (planRadios[i].checked) return planRadios[i].value || null;
        }
        return null;
      }

      function syncPlan() {
        var planId = activePlanId();
        if (planId) addBtn.setAttribute('data-selling-plan', planId);
        else addBtn.removeAttribute('data-selling-plan');
        form.querySelectorAll('[data-plan-option]').forEach(function (label) {
          var input = label.querySelector('input[name="sc-purchase"]');
          label.classList.toggle('is-active', !!(input && input.checked));
        });
      }

      function render() {
        var v = matchVariant();
        if (labelEl) labelEl.textContent = v && v.available ? 'Add to bag' : (v ? 'Sold out' : 'Unavailable');
        addBtn.disabled = !(v && v.available);
        if (v) {
          addBtn.setAttribute('data-variant-id', v.id);
          var subAmt = v.sub_price_amount || 0;
          var unit = activePlanId() && subAmt > 0 ? subAmt : v.price_amount;
          if (totalEl) totalEl.textContent = formatMoney(unit * qty, moneyFormat);
          if (oncePriceEl) oncePriceEl.textContent = formatMoney(v.price_amount, moneyFormat);
          if (subPriceEl) subPriceEl.textContent = subAmt > 0 ? formatMoney(subAmt, moneyFormat) : '';
        }
      }

      form.querySelectorAll('[data-option-position]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var pos = parseInt(chip.getAttribute('data-option-position'), 10) - 1;
          selected[pos] = chip.getAttribute('data-value');
          // Update active state within this option group.
          form.querySelectorAll('[data-option-position="' + (pos + 1) + '"]').forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on);
          });
          render();
        });
      });

      var dec = form.querySelector('[data-qty-dec]');
      var inc = form.querySelector('[data-qty-inc]');
      function setQty(n) {
        qty = Math.max(1, n);
        if (qtyValEl) qtyValEl.textContent = qty;
        addBtn.setAttribute('data-quantity', qty);
        render();
      }
      if (dec) dec.addEventListener('click', function () { setQty(qty - 1); });
      if (inc) inc.addEventListener('click', function () { setQty(qty + 1); });

      planRadios.forEach(function (radio) {
        radio.addEventListener('change', function () { syncPlan(); render(); });
      });

      syncPlan();
      render();
    });
  }

  /* ---------------------------------------------------------------------
     Newsletter — Mailchimp. Progressive enhancement: the form natively POSTs
     to Mailchimp's hosted page if JS is off; with JS we submit via Mailchimp's
     JSONP endpoint and render success / already-subscribed / error inline in
     the handwriting note slot. Never navigates away.
     --------------------------------------------------------------------- */
  function initMailchimp() {
    var cfg = window.SmalleyMailchimp || {};
    var messages = {
      success: cfg.success || "you're in — see you tomorrow morning",
      duplicate: cfg.duplicate || "you're already at the table",
      error: cfg.error || 'hmm — try that again?',
      pending: '…'
    };
    function setNote(note, text) { if (note) note.textContent = text; }

    document.querySelectorAll('[data-mc-form]').forEach(function (form) {
      var action = form.getAttribute('action') || '';
      var note = form.parentNode.querySelector('[data-mc-note]');
      var defaultNote = note ? note.textContent : '';
      var button = form.querySelector('button[type="submit"], button');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[name="EMAIL"]');
        var email = input ? input.value.trim() : '';
        if (!email || !/.+@.+\..+/.test(email)) { setNote(note, messages.error); return; }
        if (!action) { setNote(note, messages.error); return; } // not configured yet

        if (button) button.disabled = true;
        setNote(note, messages.pending);

        if (input) input.value = email; // serialize the trimmed address, not the raw one

        /* Send every named field, not just EMAIL. The group checkbox
           (group[<category>][<group>]) is what files a signup under The Paper
           Filter or The Crema, and the honeypot has to arrive — empty — or
           Mailchimp treats the post as a bot. Sending EMAIL alone, as this did,
           subscribes the reader to the audience with no publication attached. */
        var params = [];
        Array.prototype.forEach.call(form.elements, function (el) {
          if (!el.name || el.disabled) return;
          if (el.type === 'submit' || el.type === 'button') return;
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
          params.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value));
        });

        var cbName = 'scMC_' + Date.now() + '_' + Math.floor(Math.random() * 1e4);
        var jsonUrl = action.replace('/post?', '/post-json?');
        jsonUrl += (jsonUrl.indexOf('?') > -1 ? '&' : '?') + params.join('&') + '&c=' + cbName;

        var script = document.createElement('script');
        var done = false;
        function finish(text) {
          if (done) return;
          done = true;
          setNote(note, text);
          if (button) button.disabled = false;
          delete window[cbName];
          if (script.parentNode) script.parentNode.removeChild(script);
          // Restore the resting note after a beat, unless it was a success.
          if (text !== messages.success) {
            setTimeout(function () { if (note && note.textContent === text) setNote(note, defaultNote); }, 4000);
          }
        }
        window[cbName] = function (data) {
          if (data && data.result === 'success') { finish(messages.success); return; }
          var msg = (data && data.msg) || '';
          finish(/already/i.test(msg) ? messages.duplicate : messages.error);
        };
        script.onerror = function () { finish(messages.error); };
        script.src = jsonUrl;
        document.body.appendChild(script);
        setTimeout(function () { finish(messages.error); }, 8000);
      });
    });
  }

  /* ---------------------------------------------------------------------
     Nav toggle — the small-screen menu. The button is hidden above 700px by
     the stylesheet, so this is a no-op on desktop. Closes on Escape and when
     the viewport grows back past the breakpoint, so the nav can never be
     left in a collapsed state on a wide screen.
     --------------------------------------------------------------------- */
  function initNavToggle() {
    var btn = document.querySelector('[data-sc-nav-toggle]');
    var nav = document.getElementById('sc-primary-nav');
    if (!btn || !nav) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    }

    btn.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        setOpen(false);
        btn.focus();
      }
    });

    var wide = window.matchMedia('(min-width: 701px)');
    var onChange = function (e) { if (e.matches) setOpen(false); };
    if (wide.addEventListener) { wide.addEventListener('change', onChange); }
    else if (wide.addListener) { wide.addListener(onChange); }
  }

  function init() {
    initHeroRotators();
    initGeo();
    initAddToBag();
    initCartToggle();
    initNavToggle();
    initGallery();
    initProductForm();
    initMailchimp();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
